<template>
  <!--  v-if is in case the form async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.formElement)">
    <template #loading>
      <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
      >
        <template #section-header>
          <xpinner />
        </template>
      </collapsible-section>
    </template>
    <template #loaded>
      <collapsible-section
        v-if="handler.formElement"
        class="collapse-item"
        :id="`step_${handler.formElement.id}-${dropdownControlId}`"
        :control-name="`${handler.formElement.referenceNameOrDefault}Collapse`"
        :is-open="isOpen(hasFormElementMatch)"
      >
        <template #section-header>
          <row>
            <prefix>
              <icon :glyph="varIOClass(handler.variable)" />
            </prefix>
            <column>
              {{ handler.rootHeaderOrDefault }}
            </column>
          </row>
        </template>

        <template #section-contents>
          <form-element-container-data
            v-for="section in formElementSections"
            :handler="handler"
            :element-container="section.formElement"
            recurse
            :parent-tree-context="computedChildTreeContext"
            :key="section.client_id"
            @select="el => select(handler.selectFormElement(el, section.workflowStep))"
          >
            <template #after-elements>
              <collapsible-section
                v-for="section in userDataSections"
                :key="section.type"
                :id="`stepUserData-${handler.formElement.id}-${dropdownControlId}`"
                :control-name="`stepUserData-${handler.formElement.id}-${dropdownControlId}`"
                :is-open="false"
              >
                <template #section-header>
                  <row>
                    <column>
                      {{ section.header }}
                    </column>
                  </row>
                </template>

                <template #section-contents>
                  <field-item
                    v-for="field in section.fields"
                    :key="field.id"
                    :disabled="handler.isDisabled(field, parentTreeContext)"
                    @click="select(section.select(field, section.type))"
                  >
                    <row>
                      <prefix>
                        <icon :glyph="modelTypeIcon(field.modelType)"/>
                      </prefix>
                      <column>
                        {{ field.label }}
                      </column>
                    </row>
                  </field-item>
                </template>
              </collapsible-section>
            </template>
          </form-element-container-data>
        </template>
      </collapsible-section>
    </template>
  </loading>
</template>

<script lang="ts">
  import Vue from 'vue'
  import handlerComponentMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin'
  import { IDynamicTreeContext, IFormDynamicFieldSection, IUserDataSection } from "~/interfaces/dynamicFieldsInterfaces"
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'
  import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue'
  import {ProcessFlowFormElementDynamicFieldsHandler} from '~/models/dynamicFields/handlers/processFlows/processFlowFormElementDynamicFieldsHandler'
  import DynamicElementMixin from '~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue'
  import FormElementContainerData from '~/components/dynamicFieldsTrees/handlerComponents/form-element-container-data.vue'
  import FormElement from '@/formability/form_builder/models/formElements/formElement'

  export default Vue.extend({
    mixins: [
      handlerComponentMixin,
      handlerTreeContextMixin,
      DynamicElementMixin,
    ],
    components: {
      CollapsibleSection,
      FormElementContainerData,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowFormElementDynamicFieldsHandler,
        required: true,
      },
      restrictResultsToParentContext: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      formElementSections(): IFormDynamicFieldSection[] {
        return this.handler.formElementSections(this.lowerQ)
      },
      userDataSections(): IUserDataSection[] {
        return this.handler.userDataSections?.(this.lowerQ) || []
      },
      hasFormElementMatch(): boolean {
        return this.handler.hasFormElementMatch(this.lowerQ)
      },
      treeContext(): Partial<IDynamicTreeContext> {
        return {
          parent: this.handler.form,
          isTopLevelCollectionAssigned: false,
        }
      },
    },
  })
</script>